export class ApiUrl {
  /**
   * ApiUrl() gives the endpoint for the web api
   */
  public static webapiurl () {
    switch (window.location.host) {
      case 'regenl.wser.wur.nl':
        return 'https://regenl.wser.wur.nl/WebApi'
      case 'acc.regenl.wser.wur.nl':
        return 'https://acc.regenl.wser.wur.nl/WebApi'
      case 'tst.regenl.wser.wur.nl':
        return 'https://tst.regenl.wser.wur.nl/WebApi'
      default:
        return 'http://localhost:55910'
    }
  }

  public static getDataservicesUrl () {
    switch (window.location.host) {
      case 'regenl.wser.wur.nl':
        return 'https://dataservices.wser.wur.nl/'
      case 'acc.regenl.wser.wur.nl':
        return 'https://acc.dataservices.wser.wur.nl/'
      case 'tst.regenl.wser.wur.nl':
        return 'https://tst.dataservices.wser.wur.nl/'
      default:
        return 'https://tst.dataservices.wser.wur.nl/'
    }
  }
}
